import { useEffect, useState } from 'react'
import { Box, IconButton, Paper } from '@mui/material'
import Page from '../layout/Page'
import { FeatureFlags } from '../config/config'
import { OpenInNew } from '@mui/icons-material'
import { getSiteConfig } from '../community/siteProvider'


export default function CommunityForumPage(props = {}) {
  const [isLoading, setIsLoading] = useState(true)

  const [communityId, setCommunityId] = useState(null)
  const [communityUrl, setCommunityUrl] = useState(null)

  useEffect(() => {
  const { vivaCommunity } = getSiteConfig()
    if (vivaCommunity === null) {
      setCommunityId(null)
      setCommunityUrl(null)
    } else {
      if (FeatureFlags.safetyHubForum && FeatureFlags.safetyHubForumBottler) {
        setCommunityId(vivaCommunity['communityId'])
        setCommunityUrl(`${vivaCommunity['communityLinkPrefix']}${vivaCommunity['communityId']}`)
      } else if (FeatureFlags.safetyHubForum && !FeatureFlags.safetyHubForumBottler) {
        setCommunityId(vivaCommunity['nonProdCommunityId'])
        setCommunityUrl(`${vivaCommunity['nonProdCommunityLinkPrefix']}${vivaCommunity['nonProdCommunityId']}`)
      } else {
        setCommunityId(null)
        setCommunityUrl(null)
      }
    }
    setIsLoading(false)
  }, [])

  const iframeStyleString = "border: 0px; overflow: auto; width: 100%; height: 90%;"

  return (
    <Page {...props} isLoading={isLoading}
    >

      <Paper
        component="form"
        sx={{ backgroundColor: 'transparent', padding: 'unset', border: 'none', boxShadow: 'none', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', margin: 'unset' }}
      >
       { communityUrl && <>
        <Box sx={{}} typography={{ typographyVariant: 'body2'}}>
          You can update your communication preferences in Viva Engage, if desired <IconButton onClick={() => window.open(communityUrl, '_blank')}>
            <OpenInNew />
          </IconButton>
        </Box>
        <Box sx={{ height: 'calc(100vh - 2.5em)', margin: '0', padding: '0', overflow: 'hidden'}} dangerouslySetInnerHTML={{__html: `<iframe name="embed-feed" title="NAOU QSE Safety Community" src="https://engage.cloud.microsoft/embed/groups/${communityId}?header=false&footer=false&theme=light&promptText=What's%20on%20your%20mind%3F&includeFeedInformation=false" style="${iframeStyleString}"></iframe>`}} />
       </>
       }

      </Paper>
    </Page>
  )
}